<template lang="pug">
form.v-financing.financing.details(v-if="form"
		@submit.prevent="submit"
		novalidate
		autocomplete="off")
	v-loader(:loading="loading")
	.details__title(v-if="form.title") {{form.title}}
	.details__main.flc
		.details__fields
			template(v-for="(field, fieldIndex) in form.fields" :key="fieldIndex")
				.details__field.flc
					template(v-if="field.name === 'COUNTRY'")
						v-field(:field="field"
								v-model="countryValue"
								:errors="getFieldError(field)"
								@fileinput="fileInput(field, $event)"
								@fileremove="fileRemove(field, $event)"
								@remove="valueRemove(field, $event)"
								@update:model-value="fieldChanged(field, $event)")
					template(v-else-if="field.name === 'FINANCING'")
						v-field(:field="field"
								v-model="financingValue"
								:errors="getFieldError(field)"
								@fileinput="fileInput(field, $event)"
								@fileremove="fileRemove(field, $event)"
								@remove="valueRemove(field, $event)"
								@update:model-value="fieldChanged(field, $event)")
					template(v-else-if="field.name === 'LOAN_AMOUNT'")
						v-field(:field="field"
								v-model="amountVolumeValue"
								:errors="getFieldError(field)"
								@fileinput="fileInput(field, $event)"
								@fileremove="fileRemove(field, $event)"
								@remove="valueRemove(field, $event)"
								@update:model-value="changedAmount")
					template(v-else-if="field.name === 'FIRST_PAYMENT'")
						v-field(:field="field"
								v-model="firstPaymentValue"
								:errors="getFieldError(field)"
								@fileinput="fileInput(field, $event)"
								@fileremove="fileRemove(field, $event)"
								@remove="valueRemove(field, $event)"
								@update:model-value="changedFirstPayment")
					template(v-else-if="field.name === 'MONTHS'")
						v-field(:field="field"
								v-model="monthsValue"
								:errors="getFieldError(field)"
								@fileinput="fileInput(field, $event)"
								@fileremove="fileRemove(field, $event)"
								@remove="valueRemove(field, $event)"
								@update:model-value="changedMonths")
					template(v-else)
						v-field(:field="field"
								v-model="field.value"
								:errors="getFieldError(field)"
								@fileinput="fileInput(field, $event)"
								@fileremove="fileRemove(field, $event)"
								@remove="valueRemove(field, $event)"
								@update:model-value="fieldChanged(field, $event)")
		// Политика персональных данных
		.details__text-with-link.flc(v-if="form.textWithLink" v-html="form.textWithLink")
		template(v-if="form.callback")
			.details__result-wrap
				.details__result
					.details__result-sum
						.details__sum(v-if="payment") {{formatPrice(payment)}}
						.details__sum-postfix {{usingCurrency}}/мес
					.details__result-rate Ставка:&nbsp {{rate}}%
				.details__computed-fields
					template(v-if="form.callback.fields && form.callback.fields.length"
							v-for="(field, fieldIndex) in form.callback.fields"
							:key="fieldIndex")
						.details__computed-item.flc
							//-template(v-if="field.type === 'tel'")
							v-field.details__computed-field(:field="field"
									v-model="field.value"
									:errors="getFieldСallbackError(field)"
									:disabled="field.disabled"
									@fileinput="fileInput(field, $event)"
									@fileremove="fileRemove(field, $event)"
									@remove="valueRemove(field, $event)")
					button.details__switcher.form__social-switcher(v-if="socialSwitcher"
							@click.prevent="switchFieldType")
						| {{computedSwitcherText}}
				button(:type="form.callback.button.type || 'submit'"
						:class="form.callback.button.className || 'btn btn--primary'"
						:disabled="form.callback.button.disabled"
						:data-modal-url="form.callback.button.modalUrl || null"
						:data-modal-data="form.callback.button.modalData || null") {{form.callback.button.text}}
			template(v-if="!this.isLeasing")
				a.details__btn-link(v-if="form.button && form.button.link"
						:href="form.button.link"
						:class="form.button.className || ''"
						target="_blank")
					span.details__btn-link-text(v-if="form.button.text") {{form.button.text}}
					v-svg-icon.details__btn-link-icon(icon="pointer-right")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import controller from '../scripts/controller/controller';
import formattingMixin from '../components/mixins/v-mixin-formatting.vue';

export default {
	mixins: [
		sourceMixin,
		formattingMixin
	],

	props: {
		mode: {
			type: String,
			default: null
		},

		propProductData: {
			type: Object,
			default: null
		}
	},

	emits: [
		'success'
	],

	data() {
		return {
			form: null,
			localFormData: new FormData(),
			modalTimeout: null,
			confirmed: false,
			savedFileKeys: [],
			amountVolumeValue: {
				min: null,
				max: null,
				selectValue: null
			},
			firstPaymentValue: {
				min: null,
				max: null,
				selectValue: null,
				selectCurrency: null
			},
			maxAmount: null,
			usingCurrency: null,
			productData: null,
			countryValue: null,
			financingValue: null,
			isLeasing: false,
			payment: null,
			rate: null,
			monthsValue: null,
			isPhoneEntered: false,
			socialSwitcher: false,
			selectedSocial: false,
			hiddenField: null,
		};
	},

	computed: {
		computedSwitcherText() {
			return this.selectedSocial ? 'Использовать номер телефона' : 'Использовать мессенджер'
		}
	},

	methods: {
		getFieldError(field) {
			const filteredErrors = this.form.errors?.fields?.filter(item => item.name === field.name) || [];
			return filteredErrors.length ? filteredErrors : null;
		},

		getFieldСallbackError(field) {
			const filteredErrors = this.form.callback.errors?.fields?.filter(item => item.name === field.name) || [];
			return filteredErrors.length ? filteredErrors : null;
		},

		scrollToFirstError() {
			if (!this) {
				return;
			}
			if (document.body.classList.contains('state--modal-open')) {
				return;
			}
			const $errorFields = this.$el.querySelectorAll('.form-error');
			if ($errorFields.length > 0) {
				const $firstErrorField = $errorFields[0];
				const yOffset = -10;
				const coordY = $firstErrorField.getBoundingClientRect().top + window.pageYOffset + yOffset;
				window.scrollTo({top: coordY, behavior: 'smooth'});
			} else {
				window.scrollTo({top: 0, behavior: 'smooth'});
			}
		},

		proxyFieldName(name) {
			return `state[form][${name}]`;
		},

		dataSet(data) {
			if (data.success && data.closeModal) {
				if (typeof modalController !== 'undefined') {
					if (typeof (data.modalTimeout) !== 'undefined' && data.modalTimeout > 0) {
						clearTimeout(this.modalTimeout);
						this.modalTimeout = setTimeout(() => {
							controller.closeModal();
						}, data.modalTimeout);
					} else {
						controller.closeModal();
					}
				}
				return;
			}
			if (data.modal) {
				window.modalController.closeAll();
				// открыть модальное окно с сообщением об успешной отправке формы

				controller.openModal({
					className: data.modal.className,
					content: `<v-modal-window>${data.modal.content}</v-modal-window>`
				});
			}
			if (data.success) {
				this.$emit('success');
			}
			if (data.emit_event) {
				controller.emitCustomEvent(data.emit_event);
			}
			this.form = data;

			if(this.form.callback.fields?.some(field => String(field?.code).toUpperCase() === 'SOCIAL')) {
				this.socialSwitcher = true;
				const SOCIAL = 'SOCIAL'.toUpperCase();
				const PHONE = 'PHONE'.toUpperCase();
				const hasSocial = this.form.callback.fields?.some(field => field?.code?.toUpperCase() === SOCIAL);
				const hasPhone = this.form.callback.fields?.some(field => field?.code?.toUpperCase() === PHONE);
				if (hasSocial && hasPhone) {
					const targetField = this.selectedSocial ? PHONE : SOCIAL;
					this.hiddenField = this.form.callback.fields.find(field => field?.code?.toUpperCase() === targetField);
					this.form.callback.fields = this.form.callback.fields.filter(field => field?.code?.toUpperCase() !== targetField);
				}
			}
			if (this.form.productData) {
				this.productData = this.form.productData;
			} else if (this.propProductData) {
				this.productData = this.propProductData;
			}

			if(!data.success) {
				const loanAmountField = this.form.fields.find(field => field.name?.toUpperCase() === 'LOAN_AMOUNT');
				const amountMinValue = loanAmountField?.value.min || 0;
				const amountSelectValue = this.productData.currency || loanAmountField?.value.selectValue;
				let amountMaxValue;
				this.usingCurrency = this.productData.currency || this.amountVolumeValue.selectValue;
				if (this.productData.price) {
					amountMaxValue = this.productData.price * Number(this.productData.currencyRate[this.usingCurrency]) || loanAmountField?.value.max || amountMinValue;
				} else {
					amountMaxValue = loanAmountField?.value.max || amountMinValue;
				}
				this.amountVolumeValue = {
					min: amountMinValue,
					max: amountMaxValue,
					selectValue: amountSelectValue
				};
				this.countryValue = this.productData.country || (this.form.fields.find(field => field.name === 'COUNTRY')?.value || null);
				this.financingValue = this.form.fields.find(field => field.name === 'FINANCING')?.value || 0;
				this.firstPaymentValue = this.form.fields.find(field => field.name === 'FIRST_PAYMENT')?.value || 0;
				this.monthsValue = this.form.fields.find(field => field.name === 'MONTHS')?.value || 0;
				this.rate = this.productData.rate || 0;
				this.maxAmount = this.amountVolumeValue.max;
				if (this.financingValue === 'leasing') {
					this.isLeasing = true;
				}
				this.calculateLoanPayment()
			}
		},

		submit(options = {}) {
			let namesOfCurrentIteration = [];
			let isButton = options.submitter && options.submitter instanceof HTMLButtonElement;
			if (this.form && this.form.fields) {
				const combinedFields = [...this.form.fields, ...this.form?.callback?.fields];
				combinedFields.forEach(field => {
					let key = this.proxyFieldName(field.name);
					if (field.multiple) {
						key = this.proxyFieldName(field.name.replace('[]', ''));
					}
					if (!field.value) {
						field.value = '';
					}
					if (field.type === 'file') {
						// очистка полей для файлов от старых значений
						for (let item of this.localFormData.entries()) {
							let isfoundInSavedFileKeys = false;
							for (let j = 0; j < this.savedFileKeys.length; j++) {
								if (item[0].indexOf(this.savedFileKeys[j]) > -1) {
									isfoundInSavedFileKeys = true;
									break;
								}
							}
							if (item[0].indexOf(key) === 0 && !isfoundInSavedFileKeys) {
								this.localFormData.delete(item[0]);
							}
						}
					} else if (namesOfCurrentIteration.indexOf(key) < 0) {
						// очистка всех остальных полей
						if (Array.isArray(field.value)) {
							field.options?.forEach((val, index) => {
								this.localFormData.delete(`${key}[${index}]`);
								namesOfCurrentIteration.push(`${key}[${index}]`);
							});
						} else {
							this.localFormData.delete(key);
							namesOfCurrentIteration.push(key);
						}
					}
					if (field.type === 'file') {
						// обработка файлов происходит в fileInput / fileRemove
						// здесь ничего делать не нужно
						/*
						 _.each(field.value, (fileListItem) => {
						 this.localFormData.append(field.name, fileListItem.file, fileListItem.name)
						 });
						 */
					} else {
						// для отправки файлов придется держать в памяти неизменный localFormData
						// перед отправкой нужно удалить старые значения из localFormData
						// т.к. localFormData.append добавляет новые значения к существующим
						// а localFormData.set не позволила бы работать с массивами типа NAME[]
						if (field.name === 'COUNTRY') {
							this.localFormData.append(key, this.countryValue);
						} else if (field.name === 'FINANCING') {
							this.localFormData.append(key, this.financingValue);
						} else if (field.name === 'LOAN_AMOUNT') {
							this.localFormData.append(key, JSON.stringify(this.amountVolumeValue));
						} else if (field.name === 'FIRST_PAYMENT') {
							this.localFormData.append(key, JSON.stringify(this.firstPaymentValue));
						} else if (field.name === 'MONTHS') {
							this.localFormData.append(key, JSON.stringify(this.monthsValue));
						} else if (Array.isArray(field.value)) {
							field.value.forEach((val, index) => {
								this.localFormData.append(`${key}[${index}]`, val);
							});
						} else if ((typeof field.value === 'object') && (field.value !== null)) {
							this.localFormData.append(key, JSON.stringify(field.value));
						} else {
							this.localFormData.append(key, field.value);
						}
					}
				});
			}
			this.localFormData.set('state[action]', options.action || 'submit');
			this.localFormData.set('bxajaxid', this.form.bxajaxid || null);
			this.localFormData.set('productId', this.productData.id);
			this.localFormData.set('price', JSON.stringify(this.productData.price));
			this.localFormData.set('year', this.productData.year);
			this.localFormData.set('engineType', this.productData.engineType);
			this.localFormData.set('engineVolume', JSON.stringify(this.engineVolumeValue));
			this.localFormData.set('bid', this.productData.bid);
			this.localFormData.set('auctionType', this.productData.auctionType);
			this.localFormData.set('stateDelivery', this.productData.stateDelivery);
			this.localFormData.set('lemonService', JSON.stringify(this.productData.lemonService));
			this.localFormData.set('enginePower', this.productData.enginePower);
			this.localFormData.set('carAge', this.productData.carAge);
			this.localFormData.set('carEngine', this.productData.carEngine);
			this.localFormData.set('benefit', this.productData.benefit);
			this.localFormData.set('payment', this.payment);
			if (this.confirmed) {
				this.localFormData.append('confirmed', 1);
			} else {
				this.localFormData.delete('confirmed');
			}
			this.dataLoad({
				url: isButton ? this.form.callback.remote : this.form.remote,
				data: this.localFormData,
				delay: true
			});
		},

		fieldChanged(field) {
			if (field.autosubmit) {
				this.submit({action: 'autosubmit'});
			}
		},
		// Расчет
		calculateLoanPayment() {
			let firstPaymentValueMax = Math.round(this.maxAmount * (Number(this.firstPaymentValue.selectValue) / 100));
			this.lastFirstPaymentMax = firstPaymentValueMax;

			this.amountVolumeValue = {
				...this.amountVolumeValue,
				max: Math.round(this.maxAmount)
			};
			this.firstPaymentValue = {
				...this.firstPaymentValue,
				max: firstPaymentValueMax,

				selectValue: this.firstPaymentValue.selectValue,
				selectCurrency: this.usingCurrency
			};
			this.amountVolumeValue.max -= firstPaymentValueMax;
			this.lastAmount = this.amountVolumeValue.max;
			this.lastAmountSelect = this.amountVolumeValue.selectValue;
			this.payment = this.changedMonths(this.amountVolumeValue.max, this.rate, this.monthsValue.max);
		},

		// Сумма кредиты
		changedAmount() {
			const {selectValue} = this.amountVolumeValue;
			if (this.lastAmountSelect !== selectValue) {
				if (this.productData.price) {
					const amountMaxValue = this.productData.price * Number(this.productData.currencyRate[selectValue]);
					this.amountVolumeValue = {
						...this.amountVolumeValue,
						max: Math.round(amountMaxValue),
						selectValue
					};
					this.usingCurrency = selectValue;
					this.payment = this.changedMonths(this.amountVolumeValue.max, this.rate, this.monthsValue.max);
				}
				this.rate = this.productData.rate;
				this.maxAmount = this.amountVolumeValue.max;
				this.lastAmountSelect = selectValue;
				this.calculateLoanPayment();
			} else {
				this.lastAmountSelect = selectValue;
				this.amountVolumeValue.selectValue = this.lastAmountSelect;
				this.amountVolumeValue.max = Math.round(this.lastAmount);
				const calculatedMax = Math.round(this.maxAmount * (1 - (Number(this.firstPaymentValue.selectValue) / 100)));
				if (this.amountVolumeValue.max > calculatedMax) {
					this.amountVolumeValue.max = calculatedMax;
				}
				this.rate = this.productData.rate;
				this.payment = this.changedMonths(this.amountVolumeValue.max, this.rate, this.monthsValue.max);
			}
		},


		// Первый платеж
		changedFirstPayment() {
			this.firstPaymentValue.max = Math.round(this.lastFirstPaymentMax);
			this.calculateLoanPayment();
		},

		// Страна
		changedCountry() {
			//this.updateMonths();
			this.rate = this.productData.rate;
			this.payment = this.changedMonths(this.amountVolumeValue.max, this.rate, this.monthsValue.max);
		},

		// Кредит/Лизинг
		changedFinancing() {
			if (this.financingValue === 'leasing') {
				this.isLeasing = true;
			}
			if (this.financingValue === 'credit') {
				this.isLeasing = false;
			}
			this.changedCountry();
			//this.updateMonths();
		},

		// Месяцы
		changedMonths() {
			const monthlyRate = this.rate / 100 / 12;
			if (this.rate === 0) {
				return this.payment = (this.amountVolumeValue.max / this.monthsValue?.value?.max || this.monthsValue.max).toFixed(2);
			}
			const monthlyPayment = (this.amountVolumeValue.max * monthlyRate * Math.pow(1 + monthlyRate, this.monthsValue?.value?.max || this.monthsValue.max)) /
				(Math.pow(1 + monthlyRate, this.monthsValue?.value?.max || this.monthsValue.max) - 1);
			this.payment = monthlyPayment.toFixed(2);
			return this.payment;
		},

		// Разбивка процентов первого взноса с шагом в 10
		updateFieldOptions(field) {
			const existingValues = field.options.map(option => Number(option.value));
			const minPercentage = Math.min(...existingValues);
			const maxPercentage = Math.max(...existingValues);
			const updatedOptions = [];
			for (let value = minPercentage; value <= maxPercentage; value += 10) {
				if (!existingValues.includes(value)) {
					updatedOptions.push({
						value: value.toString(),
						text: `${value}%`
					});
				}
			}
			const finalOptions = [...field.options, ...updatedOptions];
			finalOptions.sort((a, b) => Number(a.value) - Number(b.value));
			return {
				...field,
				options: finalOptions
			};
		},

		fileInput(field, e) {
			this.savedFileKeys = [];
			for (let i = 0; i < e.target.files.length; i++) {
				this.savedFileKeys.push(e.key);
				this.localFormData.append(this.proxyFieldName(field.name) + '[' + e.key + ']', e.target.files[i].path || e.target.files[i]);
			}

			if (field.autosubmit && !e.nosubmit) {
				this.submit({action: 'autosubmit'});
			}
		},

		fileRemove(field, e) {
			this.localFormData.delete(this.proxyFieldName(field.name) + '[' + e.key + ']');

			if (field.autosubmit && !e.nosubmit) {
				this.submit({action: 'autosubmit'});
			}
		},

		valueRemove(field, e) {
			if (field.errors && field.errors.length) {
				field.errors.splice(e, 1);
			}
		},

		switchFieldType() {
			const SOCIAL = 'SOCIAL';
			const PHONE = 'PHONE';
			this.loading = true;
			const socialField = this.form.callback.fields?.find(field => field?.code?.toUpperCase() === SOCIAL);
			const phoneField = this.form.callback.fields?.find(field => field?.code?.toUpperCase() === PHONE);
			if (!socialField && !phoneField) {
				console.warn('Не найдены поля SOCIAL и PHONE в форме');
				return;
			}
			setTimeout(() => {
				const currentVisible = this.selectedSocial ? SOCIAL : PHONE;
				if (this.hiddenField) {
					this.form.callback.fields = [this.hiddenField, ...this.form.callback.fields];
				}
				this.hiddenField = this.selectedSocial ? socialField : phoneField;
				this.form.callback.fields = this.form.callback.fields.filter(field => field?.code?.toUpperCase() !== currentVisible);
				this.selectedSocial = !this.selectedSocial;
				this.loading = false;
			}, 300);
		},
	}
};
</script>